let $ = window.$;

var _get = function() {
    return $.ajax({
        url: '/json/shopCity.json',
        type: 'get',
        dataType: 'json',
        data: {
            siteId: window._qiwa && window._qiwa.__site_basic.siteId
        }
    });
};

module.exports = {
    _city: _get(),
    get_async: function() {
        return this._city;
    },
    reget_async: function() {
        return _get();
    },
    getByCode_async: function(code) {
        return $.when(this.get_async()).then(function(data) {
            if (!data) {
                console.error('未知错误！');
            } else if (data.code === 0 && data.item) {
                var tmp_obj = {};
                for (var i in data.item) {
                    if (data.item[i].length && data.item[i][0].cityName && data.item[i][0].cityCode) {
                        tmp_obj[data.item[i][0].cityCode] = data.item[i];
                    }
                }
                if (!code) {
                    return tmp_obj;
                } else {
                    return tmp_obj[code];
                }
            } else if (data.msg) {
                console.error(`${data.code}:${data.msg}`);
            } else {
                console.error('未知错误！');
            }
            return false;
        });
    },
    getCity_async: function() {
        return $.when(this.get_async()).then(function(data) {
            if (!data) {
                console.error('未知错误！');
            } else if (data.code === 0 && data.item) {
                var tmp = [];
                var tmp_obj = {};
                for (var i in data.item) {
                    if (data.item[i].length && data.item[i][0].cityName && data.item[i][0].cityCode) {
                        tmp_obj = {};
                        tmp_obj['name'] = data.item[i][0].cityName;
                        tmp_obj['code'] = data.item[i][0].cityCode;
                        tmp.push(tmp_obj);
                    }
                }
                return tmp;
            } else if (data.msg) {
                console.error(`${data.code}:${data.msg}`);
            } else {
                console.error('未知错误！');
            }
            return false;
        });
    },
    getCityByCode_async: function(code) {
        return $.when(this.get_async()).then(function(data) {
            if (!data) {
                console.error('未知错误！');
            } else if (data.code === 0 && data.item) {
                var tmp_obj = {};
                for (var i in data.item) {
                    if (data.item[i].length && data.item[i][0].cityName && data.item[i][0].cityCode) {
                        tmp_obj[data.item[i][0].cityCode] = data.item[i][0].cityName;
                    }
                }
                if (!code) {
                    return tmp_obj;
                } else {
                    return tmp_obj[code];
                }
            } else if (data.msg) {
                console.error(`${data.code}:${data.msg}`);
            } else {
                console.error('未知错误！');
            }
            return false;
        });
    }
};



// WEBPACK FOOTER //
// ./src/modules/sellcar/services/cityService.js